import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'María G.',
  city: 'Houston, TX'
}, {
  name: 'Ana R.',
  city: 'Miami, FL'
}, {
  name: 'Lucía P.',
  city: 'Los Angeles, CA'
}, {
  name: 'Carmen D.',
  city: 'Dallas, TX'
}, {
  name: 'Rosa M.',
  city: 'Chicago, IL'
}, {
  name: 'Patricia V.',
  city: 'Phoenix, AZ'
}, {
  name: 'Elena S.',
  city: 'San Antonio, TX'
}, {
  name: 'Sofía L.',
  city: 'New York, NY'
}, {
  name: 'Isabel T.',
  city: 'Orlando, FL'
}, {
  name: 'Valentina C.',
  city: 'Denver, CO'
}];
function getRandomMinutesAgo() {
  return Math.floor(Math.random() * 15) + 1;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutesAgo, setMinutesAgo] = useState(getRandomMinutesAgo());
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible) return;
    // Show next notification after 20 seconds
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setMinutesAgo(getRandomMinutesAgo());
      setVisible(true);
    }, 20000);
    return () => clearTimeout(showTimer);
  }, [visible]);
  const buyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-150">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-40 max-w-[280px]" data-id="element-151">
          <div className="bg-white rounded-lg shadow-lg border border-gray-100 p-3 flex items-center gap-3 cursor-pointer" onClick={() => setVisible(false)} data-id="element-152">
            {/* Product Image */}
            <div className="w-12 h-12 rounded-md overflow-hidden flex-shrink-0 bg-navy/5" data-id="element-153">
              <img src="https://cdn.magicpatterns.com/uploads/rrdQ5E7ufrpJvzL5tyeFzV/imagen_4_credito_7502B.png" alt="Producto" className="w-full h-full object-cover" data-id="element-154" />
            </div>

            {/* Info */}
            <div className="min-w-0" data-id="element-155">
              <p className="text-xs font-bold text-navy leading-tight truncate" data-id="element-156">
                {buyer.name}
              </p>
              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-157">
                compró por{' '}
                <span className="font-bold text-green-600" data-id="element-158">$9.36</span>
              </p>
              <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-159">
                {buyer.city} · hace {minutesAgo} min
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}